// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders correctly with props 1`] = `
<table>
  <thead>
    <tr>
      <th
        onClick={[Function]}
      >
        User Name
        <svg
          fill="none"
          height="1em"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          style={
            Object {
              "color": undefined,
            }
          }
          viewBox="0 0 24 24"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polyline
            points="18 15 12 9 6 15"
          />
        </svg>
      </th>
      <th
        onClick={[Function]}
      >
        Email Address
      </th>
      <th
        onClick={[Function]}
      >
        Firm / Organization
      </th>
      <th
        onClick={[Function]}
      >
        Account Type
      </th>
      <th
        onClick={[Function]}
      >
        Trial
      </th>
      <th
        onClick={[Function]}
      >
        Subscription
      </th>
      <th
        onClick={[Function]}
      >
        Academy Subscription
      </th>
      <th
        onClick={[Function]}
      >
        Last Sign In
      </th>
      <th
        onClick={[Function]}
      >
        Confirmed?
      </th>
      <th
        onClick={[Function]}
      >
        Disabled?
      </th>
      <th />
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <a
          href="/admin/users/1/edit"
        >
          First
           
          Last
        </a>
      </td>
      <td>
        email@mail.com
      </td>
      <td>
        User
      </td>
      <td>
        Individual
      </td>
      <td>
        -
      </td>
      <td>
        -
      </td>
      <td>
        -
      </td>
      <td>
        -
      </td>
      <td>
        ✕
      </td>
      <td>
        ✕
      </td>
      <td>
        <div
          className="buttons"
        >
          <button
            className="delete-button"
            onClick={[Function]}
            type="button"
          >
            <svg
              fill="none"
              height="1em"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              style={
                Object {
                  "color": undefined,
                }
              }
              viewBox="0 0 24 24"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polyline
                points="3 6 5 6 21 6"
              />
              <path
                d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
              />
            </svg>
          </button>
          <div
            className="dropdown-container dots-dropdown "
            onClick={[Function]}
          >
            <button
              className="button"
              onClick={[Function]}
              type="button"
            >
              ...
            </button>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
`;

exports[`renders correctly without props 1`] = `
<table>
  <thead>
    <tr>
      <th
        onClick={[Function]}
      >
        User Name
      </th>
      <th
        onClick={[Function]}
      >
        Email Address
      </th>
      <th
        onClick={[Function]}
      >
        Firm / Organization
      </th>
      <th
        onClick={[Function]}
      >
        Account Type
      </th>
      <th
        onClick={[Function]}
      >
        Trial
      </th>
      <th
        onClick={[Function]}
      >
        Subscription
      </th>
      <th
        onClick={[Function]}
      >
        Academy Subscription
      </th>
      <th
        onClick={[Function]}
      >
        Last Sign In
      </th>
      <th
        onClick={[Function]}
      >
        Confirmed?
      </th>
      <th
        onClick={[Function]}
      >
        Disabled?
      </th>
      <th />
    </tr>
  </thead>
  <tbody />
</table>
`;
